export const endpoints = {
  makeContactPost: "https://cms.yeasitech.com/api/gaat-iti-contact-uses",
  newsAndNoticeGet: "https://cms.yeasitech.com/api/gaat-iti-notices?populate=*",
};
